const PUBLISHERS = {
  SET_PUBLISHERS_QUERY: 'SET_PUBLISHERS_QUERY',

};

export default PUBLISHERS;
